import React, { useEffect, useState, useRef } from "react"
import { Step, FocusItem } from "./type"

type Props = {
  currentStep: Step
}

function useSMERegistrationFocusRef({ currentStep }: Props) {
  const [currentFocus, setCurrentFocus] =
    useState<FocusItem>("registrationNumber")
  const inputCompanyNameRef = useRef<HTMLInputElement>(null)
  const inputPhoneRef = useRef<HTMLInputElement>(null)
  const inputRegistrationNumberRef = useRef<HTMLInputElement>(null)
  const inputVerificationCodeRef = useRef<HTMLInputElement>(null)
  const inputPasswordRef = useRef<HTMLInputElement>(null)
  const inputRepeatPasswordRef = useRef<HTMLInputElement>(null)
  const buttonReadTermRef = useRef<HTMLButtonElement>(null)
  const buttonRegisterRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    switch (currentStep) {
      case Step.InputRegistrationNumber:
        setCurrentFocus("registrationNumber")
        inputRegistrationNumberRef.current?.focus()
        return
      case Step.InputCustomCompanyName:
        setCurrentFocus("companyName")
        inputCompanyNameRef.current?.focus()
        return
      case Step.InputPhoneNumber:
        setCurrentFocus("phone")
        inputPhoneRef.current?.focus()
        return
      case Step.InputPhoneNumberVerificationKey:
        setCurrentFocus("verificationCode")
        inputVerificationCodeRef.current?.focus()
        return
      case Step.InputPassword:
        setCurrentFocus("password")
        inputPasswordRef.current?.focus()
        return
      case Step.RepeatPassword:
        setCurrentFocus("repeatingPassword")
        inputRepeatPasswordRef.current?.focus()
        return
      case Step.BeforeReadingTerm:
        setCurrentFocus("readTerm")
        buttonReadTermRef.current?.focus()
        return
      case Step.AllDone:
        setCurrentFocus("register")
        buttonRegisterRef.current?.focus()
        return
    }
  }, [currentStep])

  return {
    currentFocus,
    setCurrentFocus,
    inputCompanyNameRef,
    inputPhoneRef,
    inputRegistrationNumberRef,
    inputVerificationCodeRef,
    inputPasswordRef,
    inputRepeatPasswordRef,
    buttonReadTermRef,
    buttonRegisterRef,
  }
}

export default useSMERegistrationFocusRef
